import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getProSum } from '@/service/operate/comprehensiveDaily';
export default function useProSummary(params) {
  var proSumaryData = ref({
    mortarPro: 0,
    stonePro: 0,
    commercialPro: 0 // 商砼产量（吨）
  });
  // 查询时间范围内停机详情
  var getProSumary = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getProSum(params.value);
          case 2:
            data = _context.sent;
            proSumaryData.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getProSumary() {
      return _ref.apply(this, arguments);
    };
  }();
  var proSumary = computed(function () {
    return [{
      desc: '骨料',
      routeName: 'ProReportAggregate',
      value: proSumaryData.value.stonePro
    }, {
      desc: '砂浆',
      routeName: 'ProReportMortar',
      value: proSumaryData.value.mortarPro
    }, {
      desc: '商砼',
      routeName: 'ProReportShangTong',
      value: proSumaryData.value.commercialPro
    }];
  });
  return [proSumary, getProSumary];
}